// extracted by mini-css-extract-plugin
module.exports = {"value":"DurationField-value-1Y2gA","select":"DurationField-select-2Uhcf","unit":"DurationField-unit-3p-yK"};